<script setup>
// Configurações → Caixas de entrada → Adicionar → WhatsApp → "WhatsApp não
// oficial": nome e número, a caixa nasce (provider nexus_wa) e o celular é
// pareado aqui mesmo. Depois segue o fluxo do Chatwoot (escolher atendentes).
// Entra no channels/Whatsapp.vue do core por um patch (custom/docs/PATCHES.md).
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useAccount } from 'dashboard/composables/useAccount';
import Button from 'dashboard/components-next/button/Button.vue';
import Pareamento from './Pareamento.vue';
import { createNexusApi, erroDaApi } from '../nexus/api';
import messages from '../nexus/i18n';

const { t } = useI18n({ messages });
const router = useRouter();
const store = useStore();
const { accountId } = useAccount();

const formulario = ref({ nome: '', telefone: '' });
const criando = ref(false);
const caixa = ref(null);

const cria = async () => {
  criando.value = true;
  try {
    const { data } = await createNexusApi(accountId.value).criaWhatsapp(
      formulario.value
    );
    caixa.value = data;
    // A lista de caixas do painel (menu, conversas) passa a ter a nova.
    store.dispatch('inboxes/get');
  } catch (error) {
    useAlert(erroDaApi(error, t('NEUXS_NEXUS.WHATSAPP.ERRO_ACAO')));
  } finally {
    criando.value = false;
  }
};

const segue = () =>
  router.replace({
    name: 'settings_inboxes_add_agents',
    params: {
      accountId: accountId.value,
      page: 'new',
      inbox_id: caixa.value.id,
    },
  });
</script>

<template>
  <div class="flex flex-col gap-4">
    <div>
      <h2 class="mb-1 text-lg font-medium text-n-slate-12">
        {{ t('NEUXS_NEXUS.WHATSAPP.NOVA_TITULO') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ t('NEUXS_NEXUS.WHATSAPP.NOVA_EXPLICA') }}
      </p>
    </div>

    <form
      v-if="!caixa"
      class="flex flex-col gap-3 max-w-lg"
      @submit.prevent="cria"
    >
      <label class="flex flex-col gap-1 text-sm text-n-slate-11">
        {{ t('NEUXS_NEXUS.WHATSAPP.NOME') }}
        <input v-model="formulario.nome" type="text" class="!mb-0" required />
      </label>
      <label class="flex flex-col gap-1 text-sm text-n-slate-11">
        {{ t('NEUXS_NEXUS.WHATSAPP.TELEFONE') }}
        <input
          v-model="formulario.telefone"
          type="tel"
          placeholder="55 84 99999-0000"
          class="!mb-0"
          required
        />
      </label>
      <div>
        <Button
          type="submit"
          :label="t('NEUXS_NEXUS.WHATSAPP.CRIAR')"
          :is-loading="criando"
        />
      </div>
    </form>

    <template v-else>
      <Pareamento
        :account-id="accountId"
        :caixa="caixa"
        :fechavel="false"
        @conectado="segue"
      />
      <div>
        <Button
          :label="t('NEUXS_NEXUS.WHATSAPP.PAREAR_DEPOIS')"
          variant="ghost"
          color="slate"
          @click="segue"
        />
      </div>
    </template>
  </div>
</template>
